<script setup>
import { ref } from "vue";
import ContentSearchField from 'shared/components/contentLibrary/contentSearchField.vue';
import { DsButton } from "@coloplast/design-system";
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary';

const contentLibrary = ref(useContentLibrary());
</script>

<template>
	<div class="c-content-library__topcontainer">
		<content-search-field
			:placeholder="contentLibrary.searchBarPlaceholder"
			@search="contentLibrary.search"
			:is-on-hero="contentLibrary.displaySearchOnHero"
		/>
		<DsButton
			v-if="contentLibrary.contentFiltersAreVisible"
			class="c-content-library__topcontainer-button"
			:class="{ 'c-content-filters__button--event-calendar': contentLibrary.isEventCalendar }"
			@click="contentLibrary.setSidebarFilters('main')"
			@keydown.enter.prevent="contentLibrary.setSidebarFilters('main')"
			:variant="true ? 'functional' : 'ghost-neutral'"
			icon-start="filter"
			size="sm"
			data-testid="content-library-filter-button"
			>
			{{ contentLibrary.filtersLabel }}
		</DsButton>
		<DsButton
			v-if="contentLibrary.monthFiltersAreVisible"
			class="c-content-library__topcontainer-button"
			:class="{ 'c-content-filters__button--event-calendar': contentLibrary.isEventCalendar }"
			@click="contentLibrary.setSidebarFilters('month')"
			@keydown.enter.prevent="contentLibrary.setSidebarFilters('month')"
			:variant="true ? 'functional' : 'ghost-neutral'"
			icon-start="calendar"
			size="sm"
			>
			{{ contentLibrary.monthFiltersLabel }}
		</DsButton>
	</div>
</template>

<style lang="scss">
.c-content-library__topcontainer-button {
    margin: 12px 12px 0 0;

	@media (min-width: 768px) {
		margin: 0 0 0 12px;
	}
}
</style>
